import { useEffect, useState, useRef } from "react";
import Constantes from "../../constantes";
import machu from "../images/Machu_Picchu.jpg"
import burj from "../images/BurjKalifa.jpg";
import china from "../images/GranMurallaChina.jpg";
import coliseo from "../images/ColiseoRomano.jpg";
import cristo from "../images/CristoRedentor.jpg";
import chichen from "../images/ChichenItza.jpg";
import petra from "../images/Petra.jpg";

const imageStrips = [
    {
        src: machu,
        alt: "Machu Picchu",
        caption: "Machu Picchu",
    },
    {
        src: coliseo,
        alt: "El Coliseo",
        caption: "El Coliseo",
    },
    {
        src: cristo,
        alt: "Cristo Redentor",
        caption: "Torre de Pisa",
    },
    {
        src: china,
        alt: "Gran Muralla China",
        caption: "Gran Muralla China",
    },
    {
        src: chichen,
        alt: "Chichén Itzá",
        caption: "Chichén Itzá",
    },
    {
        src: petra,
        alt: "La ciudad perdida de Petra",
        caption: "La ciudad perdida de Petra",
    },
    {
        src: burj,
        alt: "Burj Kalifa",
        caption: "Burj Kalifa",
    },
];

function Inicio() {
    const [cargandoPublicaciones, setCargandoPublicaciones] = useState(true);
    const [token, setToken] = useState(false);
    useEffect(() => {
        setToken(localStorage.getItem('Login'));
    }, []);

    const [publicaciones, setPublicaciones] = useState([]);
    const [offset, setOffset] = useState(0);
    const [loading, setLoading] = useState(false);
    const [hasMore, setHasMore] = useState(true);
    const scrollContainerRef = useRef(null);

    // Cargar publicaciones iniciales
    useEffect(() => {
        const cargar = async () => {
            if (token === 'true') {
                try {
                    const res = await fetch(Constantes.RUTA_API + "/publicaciones/getPublicacionesVisibles?limit=50&offset=0", {
                        method: 'GET',
                        credentials: 'include'
                    });
                    const data = await res.json();

                    console.log("Publicaciones obtenidas en Inicio:", data);

                    if (Array.isArray(data)) {
                        setPublicaciones(data);
                        setOffset(50);
                    } else {
                        setPublicaciones([]);
                    }

                } catch (err) {
                    console.error("Error al obtener publicaciones:", err);
                } finally {
                    setCargandoPublicaciones(false);
                }
            }
        };

        cargar();
    }, [token]);

    // Detectar scroll hacia abajo y cargar más publicaciones
    const handleScroll = async (e) => {
        const container = e.target;
        
        // Verificar si estamos cerca del bottom
        const isNearBottom = container.scrollHeight - (container.scrollTop + container.clientHeight) < 200;
        
        if (isNearBottom && !loading && hasMore) {
            setLoading(true);
            
            try {
                const res = await fetch(
                    Constantes.RUTA_API + `/publicaciones/getPublicacionesVisibles?limit=50&offset=${offset}`,
                    {
                        method: 'GET',
                        credentials: 'include'
                    }
                );
                const data = await res.json();
                
                if (Array.isArray(data) && data.length > 0) {
                    setPublicaciones((prev) => [...prev, ...data]);
                    setOffset((prev) => prev + 50);
                } else {
                    setHasMore(false);
                }
            } catch (err) {
                console.error("Error al cargar más publicaciones:", err);
            } finally {
                setLoading(false);
            }
        }
    };

    const [activeIndex, setActiveIndex] = useState(null);
    
    return (
        <>
            <title className="Yourny">Yourny</title>
            <div className="App text-center bg-dark" style={{ display: "flex", flexDirection: "column", height: "90vh", overflow: "hidden", boxSizing: "border-box" }}>
                <h1 style={{ margin: 0, padding: "10px", flexShrink: 0 }}>Yourny</h1>
                {token === "true" && (
                    <div 
                        ref={scrollContainerRef}
                        onScroll={handleScroll}
                        style={{ flex: 1, overflowY: "auto", boxSizing: "border-box", padding: "10px" }}>
                        {cargandoPublicaciones ? (
                            <p>Cargando publicaciones...</p>
                        ) : (
                            <div>
                                {publicaciones.map((pub) => {
                                    const imagenes = pub.imagenes ? pub.imagenes.split(",") : [];

                                    return (
                                        <div key={pub.id} className="d-flex justify-content-between align-items-start mb-4 p-3 border rounded text-dark text-start">
                                            <div className="flex-grow-1 me-3">
                                                <p><strong>{pub.contenido}</strong></p>
                                                <p>Publicado por: {pub.nombre_usuario}</p>
                                                <p>
                                                    Fecha de publicación:{" "}
                                                    {pub.fecha_publicacion
                                                        ? new Date(pub.fecha_publicacion).toLocaleString()
                                                        : "Sin fecha"}
                                                </p>
                                            </div>

                                            {imagenes.length > 0 && (
                                                <div className="d-flex flex-wrap gap-5">
                                                    {imagenes.map((img, index) => (
                                                        <img
                                                            key={index}
                                                            src={`${Constantes.RUTA_API}/images/getImage/${img}`}
                                                            height="150"
                                                            width="150"
                                                            alt={`Imagen ${index + 1}`}
                                                            className="rounded border"
                                                            loading="lazy"
                                                        />
                                                    ))}
                                                </div>
                                            )}
                                        </div>
                                    );
                                })}
                                
                                {loading && (
                                    <p style={{ textAlign: "center", color: "white" }}>Cargando más publicaciones...</p>
                                )}
                                
                                {!hasMore && publicaciones.length > 0 && (
                                    <p style={{ textAlign: "center", color: "white" }}>No hay más publicaciones</p>
                                )}
                            </div>
                        )}
                    </div>
                )}
                {token !== "true" && (<>
                    <p>Tu red social para compartir tus viajes y aventuras <strong>sin perder tu privacidad</strong></p>
                    <div className="carousel-strip justify-content-center align-items-center">
                        {imageStrips.map((img, i) => (
                            <div
                                key={i}
                                className={`strip-item ${activeIndex === i ? "active" : ""}`}
                                onMouseEnter={() => setActiveIndex(i)}
                                onMouseLeave={() => setActiveIndex(null)}
                                onTouchStart={() => setActiveIndex(i)}
                                onTouchEnd={() => setActiveIndex(null)}
                            >
                                <img src={img.src} alt={img.alt} className="img-fluid" />
                                <div className="overlay">
                                    <span>{img.alt}</span>
                                </div>
                            </div>
                        ))}
                    </div>
                </>)}
            </div>
        </>
    );
}

export default Inicio;